import UserProfile from './UserProfile';
import React from 'react';
export default UserProfile;